import React from 'react'
import { motion } from 'framer-motion'
import { Music, Users, Shield } from 'lucide-react'
import { useBrand } from '../branding/BrandProvider'

const AboutPage = () => {
  const brand = useBrand()
  return (
    <div className="pt-16 lg:pt-20 min-h-screen">
      <section className="section-padding py-20">
        <div className="container-max">
          <motion.div
            className="max-w-4xl mx-auto text-center mb-12"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            <h1 className="text-5xl font-display font-bold text-white mb-4">About
              <span className="text-gradient block">{brand.siteName}</span>
            </h1>
            <p className="text-xl text-white/70">
              Our mission is to build the most vibrant, trustworthy hub for Wichita music — discovery, participation, commerce, and community.
            </p>
          </motion.div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {[{
              icon: Music, title: 'Discovery', desc: 'Unified calendar with scrapers and moderation'
            }, {
              icon: Users, title: 'Community', desc: 'Forums, profiles, DMs, and spotlights'
            }, {
              icon: Shield, title: 'Trust', desc: 'Verified sellers, safe payments, low fees'
            }].map((f, i) => {
              const Icon = f.icon
              return (
                <motion.div key={f.title} className="glass-card p-8 text-center" initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} transition={{ delay: i * 0.1 }} viewport={{ once: true }}>
                  <Icon size={36} className="text-le-accent mx-auto mb-4" />
                  <h3 className="text-xl font-semibold text-white mb-2">{f.title}</h3>
                  <p className="text-white/70">{f.desc}</p>
                </motion.div>
              )
            })}
          </div>
        </div>
      </section>
    </div>
  )
}

export default AboutPage

